import { INTERNALS, SUBINTERNALS } from "./routes.url";

export const makeUrl = (pathname: string, url: string) => {
  const internals = INTERNALS;
  const isInInternalPage = internals.some((p) => pathname?.includes(p));
  if (isInInternalPage) {
    const subInternals = SUBINTERNALS;
    const shouldBackTwo = subInternals.find((p) => pathname?.includes(p));
    if (shouldBackTwo === "/categoria/") {
      const pathnameItems = pathname.split("/");
      if (pathnameItems.indexOf("categoria") < pathnameItems.length - 2) {
        return `../../../${url}`;
      }
    }
    if (shouldBackTwo) {
      return `../../${url}`;
    }
    return `../${url}`;
  }
  return url;
};
